import { useEffect, useState } from 'react';

export const useViewport = (): number => {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
      setWidth(window.innerWidth);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  return width;
};
